/* eslint-disable react/destructuring-assignment */
import { Group } from '@mantine/core';
import DeleteConfirmPopover from '../../../../../../../components/DeleteConfirmPopover';
import { EntityDestinationType } from '../../../../../../../models/core/entities.type';

type DataViewActionProps = {
  item: EntityDestinationType;
  confirmActionResult(items: EntityDestinationType[] | null, action: string, confirmed: boolean): void;
};

export default function DestinationFormViewActions(props: DataViewActionProps) {
  return (
    <Group>
      <DeleteConfirmPopover
        label="Excluir"
        message="Esta ação removerá o destino final."
        variant="outline"
        onConfirm={() => {
          props.confirmActionResult([props.item], 'excluir', true);
        }}
        onCancel={() => {
          props.confirmActionResult([props.item], 'excluir', false);
        }}
      />
    </Group>
  );
}
